<template>
  <div class="box">
    <!-- <img src="https://mediakit.enabot.com/eboX/img/pc/headTopImg.png" alt=""> -->
    <div class="swiper-container swiper-headTopHome">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/banner1.png" alt="">
          <!-- <div class="video-box"></div> -->
          <!-- <div class="video-box">
            <img src="../../../assets/pc/coverVideo.png" alt="" v-if="type">
            <img class="videoIcon" src="../../../assets/pc/videoIcon.png" alt="" @click="playFn" v-if="type">
            <video v-show="!type" id="video-player_html5_api" class="vjs-tech" style="border-radius:10px ;" tabindex="-1"
              preload="auto" autoplay controls="true"
              src="https://jvod.300hu.com/vod/product/af576681-08b9-4291-966a-4ce33fedbc01/5c45d5888ba94eada0f1aba6842ba13f.mp4?source=2&h265=h265/113074/2bf7a0e1281b4123885b8b54065b7623.mp4">
              <source
                src="https://jvod.300hu.com/vod/product/af576681-08b9-4291-966a-4ce33fedbc01/5c45d5888ba94eada0f1aba6842ba13f.mp4?source=2&h265=h265/113074/2bf7a0e1281b4123885b8b54065b7623.mp4"
                type="video/mp4">
              <p class="vjs-no-js"> 您的浏览器不支持 HTML 5 Video 标签，请升级浏览器。</p>
            </video>
          </div> -->
        </div>
        <div class="swiper-slide">
          <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/banner2.png" alt="">
        </div>
        <div class="swiper-slide">
          <img class="swiper-wrapper-img" src="https://mediakit.enabot.com/eboX/img/pc/banner3.png" alt="">
        </div>
        
      </div>
      <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
    </div>
    <!-- <div class="video-box">
      <img src="../../../assets/pc/coverVideo.png" alt="" v-if="type">
      <img class="videoIcon" src="../../../assets/pc/videoIcon.png" alt="" @click="playFn" v-if="type">
      <video v-show="!type" id="video-player_html5_api" class="vjs-tech" style="border-radius:10px ;" tabindex="-1"
        preload="auto" autoplay controls="true"
        src="https://jvod.300hu.com/vod/product/af576681-08b9-4291-966a-4ce33fedbc01/5c45d5888ba94eada0f1aba6842ba13f.mp4?source=2&h265=h265/113074/2bf7a0e1281b4123885b8b54065b7623.mp4">
        <source
          src="https://jvod.300hu.com/vod/product/af576681-08b9-4291-966a-4ce33fedbc01/5c45d5888ba94eada0f1aba6842ba13f.mp4?source=2&h265=h265/113074/2bf7a0e1281b4123885b8b54065b7623.mp4"
          type="video/mp4">
        <p class="vjs-no-js"> 您的浏览器不支持 HTML 5 Video 标签，请升级浏览器。</p>
      </video>
    </div> -->
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  components:{
    Swiper
  },
  data() {
    return {
      type: true,
      player: null,
      // listImg:[
      //   {
      //     img:require("https://mediakit.enabot.com/eboX/img/pc/headTopImg.png")
      //   },
      //   {
      //     img:require("https://mediakit.enabot.com/eboX/img/pc/headTopImg.png")
      //   },
      //   {
      //     img:require("https://mediakit.enabot.com/eboX/img/pc/headTopImg.png")
      //   }
      // ],
    }
  },
  mounted() {
    // this.player = document.getElementById("video-player_html5_api");
    // this.player.pause()
    // //该视频播放是否已结束
    // this.player.addEventListener('ended', () => { 
    //   this.type = true
    // }, false)
    
    this.$nextTick(()=>{
      this.pcinit()
    })
    
  },
  methods: {
    pcinit() {
      this.Swiper = new Swiper(".swiper-headTopHome", {
        // direction: 'vertical', // 垂直切换选项
        loop: true, // 循环模式选项
        autoplay:true,
        autoplay : {
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          delay: 6000,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        resistanceRatio:0
      });
    },
    // playFn() {
    //   this.type = false
    //   this.$nextTick(() => {
    //     this.player.play();
    //   })

    // }
  }
}
</script>

<style lang="scss">
.swiper-headTopHome{
  --swiper-navigation-color: #fff ;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px;/* 设置按钮大小 */
  .swiper-button-next{
    right: 40px;
  }
  .swiper-button-prev{
    left: 40px;
  }
}
.pc-swiper-video{
  position: relative;
}
.swiper-wrapper-img{
  height: auto;
  width: 100vw;
}
</style>
<style lang="scss" scoped>
.box {
  // height: 750px;
  // max-width: 1920px;
  margin: 0 auto;
  // img {
  //   width: 100%;
  //   height: 101%;
  // }

  .video-box {
    position: absolute;
    width: 19.6%;
    height: auto;
    top: 22vw;
    left: 18.75%;
    border-radius: 10px;

    img {
      width: 100%;
      height: 100%;
    }

    .videoIcon {
      width: 22.8%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      cursor: pointer;
    }
  }
}
</style>